<template>
  <div id="container">
    <Header :data="basicInfo" />
    <div class="Switch">
      <DateSwitchV2 @switchTime="SwitchTime" />
    </div>
    <div class="largeMarketStream__not-vip__tips" @click="goPay" v-if="!isVIP">
          以下内容仅为示例数据，请升级为<span class="largeMarketStream__not-vip__tips-focus">专业版年费及以上会员版本</span>
    </div>
    <statisticData :info="info" @tabLink="tabLink"></statisticData>
    <van-tabs v-model="active" title-active-color="#2A89F4" color="#2A89F4">
      <van-tab title="销售分析" name="trend" />
      <van-tab title="关联商品" name="commodity" />
      <van-tab title="关联达人" name="anchor" />
      <van-tab title="关联直播" name="live" />
      <van-tab title="关联品牌" name="brand" />
      <van-tab title="关联视频" name="delivery" />
      <van-tab title="相似店铺" name="shop" />
    </van-tabs>
    <!-- <Statistic :commodity="isVIP ? info.commodityCount  : '****'" :sales="isVIP ? info.sales : '****'" :volume="isVIP ? info.salesVolume : '****'" :live="isVIP ? info.liveCount : '****'" :anchor="isVIP ? info.anchorCount : '****'"/> -->
    <!-- <template v-if="isVIP "> -->
    <!-- <!~~用 router 的话切换 tab 返回还会先在一个个 tab 间返回，改为组件了。。~~> -->
    <component :query="query" :is="active" :isVIP="isVIP" />
    <!-- </template> -->
    <!-- <LoginOrPayModal v-if="!isVIP" :top="0" :height="600" /> -->
    <!-- <img v-if="!isVIP && active === 'trend'" src="https://s6.bihukankan.com/img/1640832776similarShop.png" alt="sample" width="100%" /> -->
    <More />
  </div>
</template>

<script>
import DateSwitchV2 from "components/DateSwitchV2";
import Header from "@/modules/shop/Header.vue";
import trend from "./_id/newtrend";
import delivery from "./_id/delivery.vue";
import commodity from "./_id/newCommodity";
import shop from "./_id/shop.vue";
import anchor from "./_id/anchor";
import brand from "./_id/brand.vue";
import live from "./_id/newLive";
import LoginOrPayModal from "components/LoginOrPayModal.vue";
import statisticData from "./_id/statistic";
// 复用品牌组件
import Statistic from "@/modules/brand/Statistic.vue";
import Show from "@/modules/brand/Show.vue";

export default {
  components: {
    Header,
    trend,
    commodity,
    anchor,
    live,
    LoginOrPayModal,
    DateSwitchV2,
    Statistic,
    Show,
    statisticData,
    brand,
    delivery,
    shop,
  },
  data() {
    return {
      query: {},
      info: {},
      basicInfo: {},
      active: "trend",
      DurationLabel: "",
      loading: false,
      statistic: {},
      isSingleDay: false,
      isVIP: this.$store.state.userLevel && this.$store.state.userLevel <= 94,
    };
  },
  computed: {},
  mounted() {
    if(!this.isVIP) {
          setTimeout(() => {
                this.$store.commit("WRITEOVERLAYSHOW", {
                  status: true,
                  textChange: "details",
                });
              }, 500);
        }
    this.$store.commit("WRITEOVERLAYSHOW", {
      textChange: "shop",
      yearVipOnly: { 0: true, 2: true },
    });
    this.getShopInfo();
  },
  watch: {
    $route: {
      deep: true,
      async handler() {
        this.query.shopId = this.$route.params.id;
        await this.getStaticsData();
        await this.getShopInfo();
      },
    },
  },
  methods: {
    goPay(){
      this.$store.commit('WRITEOVERLAYSHOW', {status: true})
    },
    tabLink(val) {
      this.active = val;
      this.scrollToBottom();
    },
    scrollToBottom() {
      const container = document.getElementById("container"); // 替换为你的容器元素ID

      container.scrollIntoView(false);
    },
    /** 选择时间 **/
    SwitchTime(obj) {
      this.$showLoading();
      this.isSingleDay = obj.timeMode === 14;
      this.query = {
        ...obj,
        shopId: this.$route.params.id,
      };
      this.getStaticsData();
    },
    /** 获取基础数据信息 **/
    async getStaticsData() {
      this.$get({
        road: "statisticShop",
        data: { shopId: this.$route.params.id },
        params: this.query,
        version: "v22",
      })
        .then((res) => {
          this.info = res.data;
          this.$toast.clear();
        })
        .catch((req) => {
          this.$toast.clear();
        });
    },
    /** 获取小店信息 **/
    async getShopInfo() {
      const res = await this.$api
        .get(`v2/shop/${this.$route.params.id}`)
        .catch((_) => ({}));
      this.basicInfo = res.data || {};
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.van-tab {
  flex: none;
}
/deep/.van-tabs__wrap--scrollable {
  flex: none;
}
.Switch {
  margin: 0px 0 12px 0;
  position: sticky;
  top: 0;
  z-index:999;
  background: #FFF;
  box-shadow: 0px 0px 12px 0px rgba(0,0, 0, 0.1);
}
.largeMarketStream__not-vip__tips {
      position: sticky;
      top: 40px;
      z-index:999;
      background: rgba(255, 80, 0, 0.08);
      box-sizing: border-box;
      padding: 0 12px;
      width: 100%;
      height: 36px;
      line-height: 36px;
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      text-align: center;
      &-focus{
        color: #FF5000;
      }
    }
</style>
